import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { setAppLanguage, type AppLanguage } from '../../i18n';
import { LANDING_PAGE_PATHS } from '../../utils/landingSeo';

interface LanguageSwitcherProps {
  className?: string;
  variant?: 'inline' | 'compact';
}

const PUBLIC_PATH_PAIRS = Object.values(LANDING_PAGE_PATHS);

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  className = '',
  variant = 'inline',
}) => {
  const { i18n, t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const current = (i18n.language?.startsWith('en') ? 'en' : 'es') as AppLanguage;

  const handleChange = (lang: AppLanguage) => {
    if (lang === current) return;

    // En paginas publicas indexables, el idioma se refleja en la URL: navegamos
    // a la ruta equivalente para que cada idioma tenga su propia URL.
    const pair = PUBLIC_PATH_PAIRS.find(
      (p) => p.es === location.pathname || p.en === location.pathname
    );
    if (pair) {
      history.push(pair[lang]);
      return;
    }

    setAppLanguage(lang);
  };

  return (
    <div
      className={`language-switcher language-switcher--${variant} ${className}`.trim()}
      role="group"
      aria-label={t('common.languageLabel')}
    >
      <button
        type="button"
        className={`language-switcher__btn ${current === 'es' ? 'active' : ''}`}
        onClick={() => handleChange('es')}
        aria-pressed={current === 'es'}
      >
        ES
      </button>
      <button
        type="button"
        className={`language-switcher__btn ${current === 'en' ? 'active' : ''}`}
        onClick={() => handleChange('en')}
        aria-pressed={current === 'en'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
